import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import '../index.css';
import { IResult } from '../../components/infrastructure/models';
import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { Core } from '../../components/infrastructure/core';
import AppContext from '../../components/infrastructure/appContext';
import { Captcha } from '../../components/captcha';
import SimplePage from '../../home/simplePage';

interface IForgetPasswordState {
    success?: boolean;
    userName?: string | null;
    currentPassword?: string | null;
    loading?: boolean;
}

interface IResetPasswordData {
    userName: string;
    code: string;
    newPassword: string;
    confirmPassword: string;
}

export const ResetPassword = () => {
    const { params, getUserInfo } = useContext(AppContext);
    const userInfo = getUserInfo();

    const [state, setState] = React.useState<IForgetPasswordState>({
        success: false,
        userName: userInfo?.userName ?? params['username'],
        currentPassword: params['code']
    });

    const [form] = Form.useForm();

    const onFinish = async (values: any) => {
        if (state.loading)
            return;
        setState({ loading: true, userName: state.userName, currentPassword: state.currentPassword });
        let response = await fetch("api/user/resetpassword", {
            method: 'POST',
            body: JSON.stringify({
                userName: values['userName'],
                currentPassword: values['currentPassword'],
                newPassword: values['newPassword'],
                captcha: values['captcha']
            }),
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });

        let result: IResult = await response.json();
        if (!result.ValidationState.Successful) {
            Core.errorNotification(result.ValidationState.ValidationResults[0].Message);
            setState({ loading: false, userName: state.userName, currentPassword: state.currentPassword });
        }
        else {
            Core.successNotification('کلمه عبور با موفقیت بازنشانی شد');
            setState({ success: true, userName: state.userName, currentPassword: state.currentPassword });
        }
    };

    if (state.success) {
        if (userInfo?.userName)
            return (<Redirect to={'/'} />);
        else {
            const data = form.getFieldsValue() as IResetPasswordData;
            return (<Redirect to={{ pathname: '/login', search: '?username=' + data.userName }} />);
        }
    }

    return (
        <SimplePage>
            <div className="box box-blue" style={{ border: "1px solid white", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                <img src={'/forgetpassword.png'} style={{ marginTop: 20, width: 80 }} alt="" />
                <p className="" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: 18, fontWeight: "bold", color: "antiquewhite" }}>بازنشانی کلمه عبور</p>
            </div>
            <Form
                form={form}
                //labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
                name="normal_login"
                className="box login-form"
                initialValues={{ userName: state.userName }}
                onFinish={onFinish}
                style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 50, paddingTop: 5, border: "1px solid white", backgroundColor: "#fefefe90", borderBottomLeftRadius: 15, borderBottomRightRadius: 15, width: "100%" }}
            >
                <Form.Item
                    name="userName"
                    //label="نام کاربری"
                    rules={[{ required: true, message: 'لطفا نام کاربری را وارد نمایید' }]}
                >
                    <Input autoComplete="off" disabled={!!state.userName} prefix={<UserOutlined className="site-form-item-icon" />} placeholder="نام کاربری" />
                </Form.Item>
                <Form.Item
                    name="currentPassword"
                    //label="کلمه عبور فعلی"
                    rules={[{ required: true, message: 'لطفا کلمه عبور فعلی را وارد نمایید' }]}
                    initialValue={state.currentPassword}
                    hidden={!!state.currentPassword}
                >
                    <Input type="password" autoComplete="off" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="کلمه عبور فعلی" />
                </Form.Item>
                <Form.Item
                    //label="کلمه عبور جدید"
                    name="newPassword"
                    rules={[
                        { required: true, message: 'لطفا کلمه عبور جدید را وارد نمایید' },
                        {
                            validator: () => {
                                const data = form.getFieldsValue() as IResetPasswordData;
                                if (data.newPassword && data.newPassword.length < 8)
                                    return Promise.reject(new Error('کلمه عبور جدید باید حداقل 8 کاراکتر باشد'));
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="کلمه عبور جدید"
                        autoComplete="off"
                    />
                </Form.Item>
                <Form.Item
                    //label="تکرار کلمه عبور جدید"
                    name="confirmPassword"
                    rules={[
                        { required: true, message: 'لطفا کلمه عبور جدید را تکرار نمایید' },
                        {
                            validator: () => {
                                const data = form.getFieldsValue() as IResetPasswordData;
                                if (data.confirmPassword && data.newPassword !== data.confirmPassword)
                                    return Promise.reject(new Error('تکرار کلمه عبور جدید صحیح نیست'));
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="تکرار کلمه عبور جدید"
                        autoComplete="off"
                    />
                </Form.Item>

                {!state.loading &&
                    <Captcha
                        form={form}
                        name="captcha"
                        label="متن تصویر"
                    />
                }

                <Form.Item style={{ float: 'left' }}>
                    <Button type="primary" htmlType="submit" className="login-form-button" loading={state.loading}>
                        بازنشانی رمز عبور
                    </Button>
                </Form.Item>
                <Form.Item style={{ float: 'left' }}>
                    <Button type="default" htmlType="reset" className="login-form-button" loading={state.loading} onClick={() => {
                        setState({ success: true });
                    }}>
                        لغو
                    </Button>
                </Form.Item>

            </Form>
        </SimplePage>
    );
};

